import {
  PRODUCT_IDS,
  PRODUCT_FAMILY_ID_EVCORE,
  SUBSTITUTION_QUESTIONS_VISIBLE_FOR_EVCORE,
} from 'constants/AppConstants';
import { PRODUCT_SUBSTITUTIONS_OPTIONS } from './SubstitutionsAndCustomization.constants';

function getQuestionsForProduct(primaryProduct, addon) {
  switch (primaryProduct) {
    case PRODUCT_IDS.BidPerfect:
      return ['bidPerfectToQS', 'quickSquaresToQSECOK', 'residential2CommercialOK', 'bidPerfectCommercialToPremiumCommercial', 'eC2DReportOK'];
    case PRODUCT_IDS.BidPerfectCommercial:
      return ['bidPerfectCommercialToPremiumCommercial', 'eC2DReportOK', 'commercialToResidential', 'bidPerfectToQS', 'quickSquaresToQSECOK'];
    case PRODUCT_IDS.QuickSquaresMultiFamily:
      return ['commercialToResidential', 'bidPerfectToQS', 'quickSquaresToQSECOK', 'residential2CommercialOK',
        'bidPerfectCommercialToPremiumCommercial', 'eC2DReportOK'];
    case PRODUCT_IDS.ResWallWinDoor:
      return ['wallsOnlyToWallsLiteOK', 'residential2CommercialOK'];
    case PRODUCT_IDS.PremiumCommercialWallonly:
      return ['wallsOnlyToWallsLiteOK', 'commercialToResidential'];
    case PRODUCT_IDS.ClaimsReadyResidential:
    case PRODUCT_IDS.ECPremiumResidential:
      if (!addon) return ['eC3DReportOK', 'eC2DReportOK', 'residential2CommercialOK'];
      if (addon === PRODUCT_IDS.ResWallsFKALiteAddOn) return ['residential2CommercialOK', 'fullHouseToQS', 'eC3DReportOK', 'eC2DReportOK'];
      if (addon === PRODUCT_IDS.ResWallWinDoorAddOn) {
        return ['residential2CommercialOK', 'wallsOnlyToWallsLiteOK',
          'fullHouseToQS', 'eC3DReportOK', 'eC2DReportOK'];
      }
      return [];
    case PRODUCT_IDS.ClaimsReadyCommercial:
    case PRODUCT_IDS.ECPremiumCommercial:
      if (!addon) return ['eC3DReportOK', 'eC2DReportOK', 'commercialToResidential'];
      if (addon === PRODUCT_IDS.WallsAddOn) return ['commercialToResidential', 'wallsOnlyToWallsLiteOK', 'fullHouseToQS', 'eC3DReportOK', 'eC2DReportOK'];
      return [];
    case PRODUCT_IDS.WholeHome:
      return ['residential2CommercialOK', 'fullHouseToQS', 'eC3DReportOK', 'eC2DReportOK'];
    case PRODUCT_IDS.Full_House:
      return ['fullHouseToRoofOnlyOK'];
    case PRODUCT_IDS.GutterResidential:
      return ['residential2CommercialOK'];
    case PRODUCT_IDS.GutterCommercial:
      return ['commercialToResidential'];
    case PRODUCT_IDS.WallWinDoor:
      return ['wallsOnlyToWallsLiteOK'];
    case PRODUCT_IDS.Roof:
      return ['roof3DToRoof2DOK'];
    default:
      return [];
  }
}

const getSubstitutionQuestions = (primaryProduct, addon, productFamilyId) => {
  const questions = getQuestionsForProduct(primaryProduct, addon);
  if (productFamilyId === PRODUCT_FAMILY_ID_EVCORE) {
    return questions.filter((key) => SUBSTITUTION_QUESTIONS_VISIBLE_FOR_EVCORE.includes(key));
  }
  return questions;
};

export const getSubstitutionKey = (value) => Object.keys(PRODUCT_SUBSTITUTIONS_OPTIONS).find(
  (key) => PRODUCT_SUBSTITUTIONS_OPTIONS[key] === value,
);

export default getSubstitutionQuestions;
